<template>
  <div v-if="creatingProgram || programExists">
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <div class="row">
            <div class="col d-flex align-items-center">
              <div>
                <h6 class="header-pretitle">Program Detail</h6>
                <h1 class="header-title" v-if="creatingProgram">Add Program</h1>
                <h1 class="header-title" v-else>{{ program.name }}</h1>
              </div>
            </div>
            <div class="col-auto d-flex align-items-center" v-if="viewingManagerAssignments">
              <button
                type="button"
                class="btn btn-sm btn-outline-info"
                data-toggle="modal"
                data-target=".modal-new-user-manager">
                <font-awesome :icon="['far', 'plus']"/> Create Manager
              </button>
            </div>
          </div>
        </div><!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">
      <component :is="navComponent"/>

      <router-view :creating="creatingProgram"/>

      <LogCard v-if="$userIsAdmin" class="mt-5" type="program" />
    </div><!-- /.container-fluid -->

    <LogDrawer v-if="$userIsAdmin" type="program" :target="program"/>
  </div>
</template>

<script>
import { LogCard, LogDrawer } from 'components/log'
import { programMethods, programComputed } from 'vx/helpers'
import ProgramsSingleNavAdmin from './ProgramsSingleNavAdmin'
import ProgramsSingleNavCoordinator from './ProgramsSingleNavCoordinator'

export default {
  props: {
    id: {
      required: false,
      type: Number
    }
  },

  components: {
    LogCard,
    LogDrawer,
    ProgramsSingleNavAdmin,
    ProgramsSingleNavCoordinator
  },

  computed: {
    ...programComputed,

    viewingManagerAssignments () {
      return this.$route.name === 'programs.managers'
    },

    navComponent () {
      if (this.$userIsAdmin) {
        return ProgramsSingleNavAdmin
      } else if (this.$userIsCoordinator) {
        return ProgramsSingleNavCoordinator
      }

      return null
    },

    creatingProgram () {
      return this.$route.name === 'programs.create'
    }
  },

  beforeDestroy () {
    this.resetProgram()
  },

  async created () {
    if (this.creatingProgram) {
      return
    }

    if (this.$route.name === 'programs.edit') {
      this.$router.replace({ name: 'programs.details' })
    }

    await this.getProgram(this.id)
  },

  methods: {
    ...programMethods
  }
}
</script>
